import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './ShopProfileActions.scss';

import { setAnalyticsMode } from '../../../Actions/UIActions';
import { isAnalyticsMode } from '../../../Helpers/ui_helpers';
import { isShopper } from '../../../Helpers/user_helpers';

import Loader from '../../Loader/Loader';

const ShopProfileActions = props => {
  const { ui, isFetchingAnalytics, isSavingShopData, isEditingShopData, user } = props;
  const analyticsOn = isAnalyticsMode(ui);

  return (
    <div className='shop-profile-actions-container'>
      <div className='actions'>
        {isEditingShopData ? (
          <>
            <div onClick={() => props.doneEditingShopData(false)} className='action'>
              Cancel
            </div>
            <div onClick={() => props.doneEditingShopData(true)} className='action primary'>
              {isSavingShopData ? 'Saving...' : 'Save'}
            </div>
          </>
        ) : (
          <div onClick={props.startEditingShopData} className='action'>
            {isShopper(user) ? 'Edit Info' : 'Edit Info'}
          </div>
        )}
        {!isShopper(user) && !isEditingShopData && (
          <div onClick={() => props.setAnalyticsMode(!analyticsOn)} className={cn('action', { loading: isFetchingAnalytics })}>
            {analyticsOn ? 'Hide Analytics' : 'Show Analytics'}
            {isFetchingAnalytics && <Loader size={48} />}
          </div>
        )}
        {/* <div className='action'>Share</div> */}
      </div>
    </div>
  );
};

ShopProfileActions.propTypes = {
  // From Inside
  user: PropTypes.object.isRequired,
  ui: PropTypes.object.isRequired,
  setAnalyticsMode: PropTypes.func.isRequired,

  // From Outside
  isSavingShopData: PropTypes.bool.isRequired,
  isEditingShopData: PropTypes.bool.isRequired,
  startEditingShopData: PropTypes.func.isRequired,
  doneEditingShopData: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { user, ui } = state;
  return { user, ui };
};
export default connect(mapStateToProps, {
  setAnalyticsMode
})(ShopProfileActions);
